module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAyMCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik03IDE0TDguNDEgMTIuNTlMMy44MyA4SDIwVjZIMy44M0w4LjQyIDEuNDFMNyAwTDAgN0w3IDE0WiIgZmlsbD0iIzMyMzIzMiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-dang-left.svg
// module id = 0J62
// module chunks = 1